import moment from 'moment';
import template from './date-selector.html';

export default angular.module('app.holding.dashboard.onboarding')
  .directive('gmwDateSelector', gmwDateSelector)
  .name;

function gmwDateSelector(
) {
  'ngInject';

  const limitDate = moment().subtract(18, 'y');

  return {
    link,
    restrict: 'E',
    require: ['ngModel', '^^form'],
    replace: true,
    scope: {
      dateLimit: '=?',
      label: '@?',
    },
    template,
  };

  function link(scope, _elem, attrs, ctrls) {
    const ngModel = ctrls[0];
    const form = ctrls[1];
    scope.model = {};
    scope.dayOptions = range(1, 31).map(value => ({
      value,
      label: moment({ day: value, month: 0 }).format('DD'),
    }));
    scope.monthOptions = range(0, 11).map(value => ({
      value,
      label: moment({ month: value }).format('MMMM'),
    }));

    const dateOfBirth = Object.prototype.hasOwnProperty.call(attrs, 'dateOfBirth');
    const future = Object.prototype.hasOwnProperty.call(attrs, 'future');

    let years;
    if (dateOfBirth) {
      years = range(moment().year() - 18, 1900);
    } else if (future) {
      years = range(moment().year(), 2100);
    } else {
      years = range(moment().year(), 1900);
    }
    scope.yearOptions = years.map(value => ({
      value,
      label: moment({ year: value }).format('YYYY'),
    }));

    scope.$watchGroup(['model.day', 'model.month', 'model.year'], onUpdate);

    ngModel.$formatters.push((value) => {
      const date = moment(value);
      if (value && date.isValid()) {
        scope.model.day = date.date();
        scope.model.month = date.month();
        scope.model.year = date.year();
      }
    });

    function checkDate(date) {
      const today = moment();
      if (dateOfBirth) {
        return date.isSameOrBefore(limitDate);
      } else if (future) {
        return date.isAfter(today);
      } else if (scope.dateLimit) {
        return date.isSameOrAfter(scope.dateLimit);
      }
      return true;
    }

    function setValidity(key, value) {
      form.day.$setValidity(key, value);
      form.month.$setValidity(key, value);
      form.year.$setValidity(key, value);
    }

    function onUpdate([day, month, year]) {
      if (day !== undefined && month !== undefined && year !== undefined) {
        const date = moment({ day, month, year });
        if (date.isValid() && checkDate(date)) {
          ngModel.$setViewValue(date.format('YYYY-MM-DD'));
          setValidity('validDate', true);
          setValidity('dateLimit', true);
          scope.valid = true;
        } else {
          ngModel.$setViewValue(undefined);
          if (!date.isValid()) {
            setValidity('validDate', false);
          }
          if (!checkDate(date)) {
            setValidity('dateLimit', false);
          }
          scope.valid = false;
        }
      }
    }
  }
}

function range(start, stop) {
  const step = start > stop ? -1 : 1;
  const result = [];
  for (let i = start; step > 0 ? i <= stop : i >= stop; i += step) {
    result.push(i);
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/directives/date-selector/date-selector.js